// extracted by mini-css-extract-plugin
module.exports = {"container":"emoji-picker-container__3OALB","icon":"emoji-picker-icon__3eb1i","picker":"emoji-picker-picker__8a-g4"};